import styled from 'styled-components';
import { sublistItemInner } from 'app/theme';

// styled.li`
export const Item = styled.li.attrs({ className: 'menu__item' })`
  display: block;

  & > .menu__link {
    ${sublistItemInner}
    justify-content: flex-start;

    &._active {
      background-color: ${({ theme }) => theme.color.rgbaWhite('.05')};
      color: #F39696;
    }

    & > .svg-account,
    & > .svg-tickets,
    & > .svg-history,
    & > .svg-logout,
    & > .svg-bonus-card-2,
    & > .svg-gift-card,
    & > .svg-heart {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      fill: ${({ theme }) => theme.color.accent};
    }
  }

  & + & {
    border-top: 1px solid ${({ theme }) => theme.color.borderDark};
  }
             a:focus {
        outline: 2px solid rgb(6, 85, 146);  
        outline-offset: 2px;    
}
             :focus {
        outline: 2px solid rgb(6, 85, 146);  
        outline-offset: 2px;    
}
`;

export const List = styled.ul.attrs({
  className: 'menu'
})`
  ${({ isRounded }) =>
    isRounded &&
    `
    .menu__link {
      text-transform:none
    }
    ${Item} {
      &:first-child > .menu__link {
        border-radius: 7px 7px 0 0;
      }
    
      &:last-child > .menu__link {
        border-radius: 0 0 7px 7px;
      }
    
      &:only-child > .menu__link {
        border-radius: 7px;
      }
    }
  .menu {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
  }

  .menu a {
    tabindex: -1;
  }
  `}
`;
